// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmationWindow_fixedMid__7U6R2 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100vw;
    left: 50%;
    bottom: 50%;
    position: fixed;
    z-index: 1300;
    padding: 20px;
    transform: translate(-50%, 50%);
}

.ConfirmationWindow_windowBox__tTBZ- {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px;
    border-radius: 10px;
    gap: 10px;
}

.ConfirmationWindow_buttonBox__0J33O {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding: 10px;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ConfirmationWindow.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;IACb,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb","sourcesContent":[".fixedMid {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    width: 100vw;\n    left: 50%;\n    bottom: 50%;\n    position: fixed;\n    z-index: 1300;\n    padding: 20px;\n    transform: translate(-50%, 50%);\n}\n\n.windowBox {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding: 20px;\n    border-radius: 10px;\n    gap: 10px;\n}\n\n.buttonBox {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    padding: 10px;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fixedMid": `ConfirmationWindow_fixedMid__7U6R2`,
	"windowBox": `ConfirmationWindow_windowBox__tTBZ-`,
	"buttonBox": `ConfirmationWindow_buttonBox__0J33O`
};
export default ___CSS_LOADER_EXPORT___;
